// extracted by mini-css-extract-plugin
module.exports = {"notification":"styles_notification__1cNhL","notificationStatus":"styles_notificationStatus__2PKOg","active":"styles_active__23cYs"};